import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Decor_common.png'


const _withScopeId = n => (_pushScopeId("data-v-38bbc50f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-state"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "create__title" }, "Тема часа:", -1))
const _hoisted_3 = {
  key: 0,
  class: "create__text"
}
const _hoisted_4 = {
  key: 3,
  class: "create__tip create__tip-gradient"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "create__tip_text" }, [
  /*#__PURE__*/_createTextVNode(" Вы можете создать неограниченное количество изображений. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Нейросеть создает по вашему запросу изображения, которые вы впоследствии публикуете, получаете лайки и делитесь ими с знакомыми. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 4,
  class: "create__tip create__tip"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "create__tip_text" }, " До завершения генерации картинки всего ~2-3 мин. ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "create__title" }
const _hoisted_13 = { class: "create__creations" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create__creation_checkbox" }, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "create__tip"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "create__tip_text" }, " Выберете одну из работ представленных выше или попробуйте снова ", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "create__title" }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "create__liking_title-container" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "create__liking_title" }, " Пролайкайте 10 работ, чтобы получить доступ к публикации ", -1))
const _hoisted_25 = { class: "create__liking_count" }
const _hoisted_26 = { class: "create__liking_cards" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create__liking_card_overlay" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create__liking_card_overlay" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create__liking_card_author" }, null, -1))
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "create__finished_title" }, "Работа опубликована", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "create__finished_text" }, " Вы увидите свою работу в ленте. Количество лайков и реакций возможно увидеть после того, как закончится актуальная тема часа. ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tour__illustrations",
  "data-format": "left-right"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "tour__illustration" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "41",
      height: "33",
      viewBox: "0 0 41 33",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M39.1501 30.7637C39.1501 30.7637 38.3352 8.50193 2 8.47314M2 8.47314L10.9567 1.79134M2 8.47314L8.70411 17.4597",
        stroke: "white",
        "stroke-width": "3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "Лайкнуть")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "tour__illustration" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "41",
      height: "33",
      viewBox: "0 0 41 33",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M2.19561 30.7642C2.19561 30.7642 3.01051 8.50242 39.3457 8.47363M39.3457 8.47363L30.389 1.79183M39.3457 8.47363L32.6416 17.4602",
        stroke: "white",
        "stroke-width": "3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "Пропустить")
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "create__decor",
  src: _imports_0
}, null, -1))

import { onBeforeMount, onUnmounted, ref, Ref, watch } from 'vue';
import { Swipeable } from 'vue-swipy';
import { toast } from 'vue3-toastify';
import { WorksSevice, WorkItem } from '../services/WorksService';
import { GenerationService } from '../services/GenerationService';
import BaseLoader from '@/components/shared/BaseLoader.vue';
import { CacheService } from '@/services/base/CacheService';
import BaseTour from '@/components/shared/BaseTour.vue';
import { OnboardSevice } from '@/services/OnboardService';
import { TourService } from '@/services/TourService';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateView',
  setup(__props) {

const topic: Ref<null | string> = ref(null);
const topicHour: Ref<null | number> = ref(new Date().getHours());
const topicCheckInterval: Ref<null | number> = ref(null);
onBeforeMount(async () => {
	// Update prompt (without cache)
	await updatePrompt();

	// Recheck topic (every 10 seconds)
	topicCheckInterval.value = setInterval(() => {
		if (state.value !== 'initial') {
			return;
		}

		// New hour -> new topic
		const newTopicHour = new Date().getHours();
		if (topicHour.value !== newTopicHour) {
			// Update topic
			updatePrompt();
			// Update hour
			topicHour.value = newTopicHour;
		}
	}, 1000 * 10);
});
onUnmounted(() => {
	clearInterval(topicCheckInterval.value as number);
});

async function updatePrompt() {
	const topicResult = await WorksSevice.getTopic();

	// Success
	if (topicResult.result === true) {
		topic.value = topicResult.topic.trim();
	}
	// Fail
	else {
		toast.error('Не получилось получить тему часа');
	}
}

const prompt: Ref<string> = ref('');
const images: Ref<string[]> = ref([]);
const chosenImage: Ref<number | null> = ref(null);
const state: Ref<
	'initial' | 'generating' | 'choosing' | 'chosen' | 'liking' | 'finished'
> = ref('initial');
watch(state, (val) => {
	if (val === 'liking') {
		showLikeTour.value = true;
	}
});

async function generateImage(newTopic = false) {
	state.value = 'generating';

	// Fetch new topic
	if (newTopic) {
		const topicResult = await WorksSevice.getTopic();
		topic.value = topicResult.topic.trim();
	}

	// Generate images
	GenerationService.generate(prompt.value, (_images: string[] | null) => {
		if (_images === null) {
			state.value = 'initial';
			toast.error('На вашем балансе недостаточно burn-коинов :(');
			return;
		}

		// Load works for likes
		loadWorksForLikes().then(() => {
			state.value = 'choosing';
			images.value = _images;

			// Show onboard
			if (OnboardSevice.onboardTourState?.finished === false) {
				TourService.changeStep(4); // 4 -> choose_work
			}
		});
	});
}

const showLikeTour: Ref<boolean> = ref(false);
const likeProgress: Ref<number> = ref(0);
const works: Ref<WorkItem[]> = ref([]);
async function loadWorksForLikes() {
	const resp = await WorksSevice.getWorksForLikes();
	works.value = resp.items;

	addItemFromWorks();
}
function addItemFromWorks(): boolean {
	const work = works.value.pop();
	if (work) {
		stack.value.unshift(work);
		return true;
	} else {
		return false;
	}
}

const stack: Ref<WorkItem[]> = ref([]);
async function addCard() {
	stack.value.pop();

	if (!addItemFromWorks() && !isPublishing.value) {
		await publishWork();
	}
}
function onSwipe(dir: string) {
	if (dir === 'swipe-left') {
		const workId = stack.value[0].id;

		// Send like
		WorksSevice.likeWork(workId).then(() => {
			WorksSevice.likedWorks = {
				...WorksSevice.likedWorks,
				[workId]: true
			};
		});
	}

	likeProgress.value++;
	addCard();
}

const isPublishing: Ref<boolean> = ref(false);
async function publishWork() {
	if (chosenImage.value === null) return;

	isPublishing.value = true;
	await WorksSevice.publishWork(
		images.value[chosenImage.value],
		prompt.value
	);

	state.value = 'finished';
	CacheService.set('feed', undefined);

	// Show onboard
	if (OnboardSevice.onboardTourState?.finished === false) {
		TourService.changeStep(5); // 5 -> published
	}
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: "view create",
    "data-state": state.value
  }, [
    (state.value === 'initial' || state.value === 'generating')
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "create__form",
          action: "",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (generateImage()), ["prevent"]))
        }, [
          _hoisted_2,
          (topic.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "«" + _toDisplayString(topic.value) + "»", 1))
            : (_openBlock(), _createBlock(BaseLoader, {
                key: 1,
                size: "sm"
              })),
          (topic.value)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 2,
                class: "create__field",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((prompt).value = $event)),
                type: "text",
                placeholder: "Введите промпт",
                maxlength: 75
              }, null, 512)), [
                [_vModelText, prompt.value]
              ])
            : _createCommentVNode("", true),
          (state.value === 'initial')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : (state.value === 'generating')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: _normalizeClass(`create__button button button-dark button-md ${
					state.value === 'generating' ? 'button-loading' : ''
				}`),
            type: "submit",
            disabled: state.value !== 'initial' || !topic.value
          }, [
            (state.value === 'initial')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Создать"))
              : (_openBlock(), _createBlock(BaseLoader, {
                  key: 1,
                  size: "sm"
                }))
          ], 10, _hoisted_10)
        ], 32))
      : (state.value === 'choosing')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("h2", _hoisted_12, _toDisplayString(prompt.value), 1),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: _normalizeClass(`create__creation ${
						chosenImage.value === idx ? 'checked' : ''
					}`),
                  onClick: ($event: any) => (chosenImage.value = idx)
                }, [
                  _createElementVNode("img", {
                    class: "create__creation_image",
                    src: image,
                    alt: `Вариант ${idx + 1}`
                  }, null, 8, _hoisted_15),
                  _hoisted_16
                ], 10, _hoisted_14))
              }), 128))
            ]),
            (chosenImage.value === null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "create__button button button-primary button-md",
                  type: "button",
                  disabled: chosenImage.value === null,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (state.value = 'chosen'))
                }, " Продолжить ", 8, _hoisted_20)),
            _createElementVNode("button", {
              class: "create__button button button-dark button-md",
              type: "submit",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (generateImage(true)))
            }, " Перегенерировать ")
          ], 64))
        : (state.value === 'chosen' && chosenImage.value !== null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("h2", _hoisted_21, _toDisplayString(prompt.value), 1),
              _createElementVNode("img", {
                class: "create__image",
                src: images.value[chosenImage.value],
                alt: `Вариант ${chosenImage.value + 1}`
              }, null, 8, _hoisted_22),
              _createElementVNode("button", {
                class: "create__button button button-primary button-md",
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (state.value = 'liking'))
              }, " Опубликовать ")
            ], 64))
          : (state.value === 'liking')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("p", _hoisted_25, _toDisplayString(likeProgress.value) + "/10", 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stack.value, (card) => {
                    return (_openBlock(), _createBlock(_unref(Swipeable), {
                      key: card.id,
                      onSwipe: onSwipe,
                      class: "create__liking_card"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27,
                        _hoisted_28,
                        _hoisted_29,
                        _createElementVNode("img", {
                          src: card.image_url,
                          alt: card.description
                        }, null, 8, _hoisted_30),
                        _createElementVNode("p", null, _toDisplayString(card.description), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ], 64))
            : (state.value === 'finished')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _hoisted_31,
                  _hoisted_32,
                  _createVNode(_component_RouterLink, {
                    to: "/",
                    class: "create__button button button-light button-md"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Перейти в ленту ")
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
    (showLikeTour.value)
      ? (_openBlock(), _createBlock(BaseTour, {
          key: 5,
          title: 
				_unref(OnboardSevice).onboardTourState?.finished === false
					? 'Лайкинг'
					: 'Выбор работы'
			,
          text: 
				_unref(OnboardSevice).onboardTourState?.finished === false
					? `Для того, чтобы опубликовать работу необходимо пролайкать понравившиеся работы.
			Таким образом вы сможете шерить свои картинки и монетизировать их.`
					: `Здесь все просто :)
			Свайп влево - вы лайкнули работу.
			Свайп вправо - вы пропустили работу.
			`
			,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (showLikeTour.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        }, 8, ["title", "text"]))
      : _createCommentVNode("", true),
    _hoisted_34
  ], 8, _hoisted_1))
}
}

})